import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeading } from "@/components/Reveal";

// Homepage entry to «فنادق مقترحة». Renders only once at least one verified
// hotel is published (the section appears automatically after the first publish).
export const HotelsTeaser = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/hotels").then(({ data }) => setData(data)).catch(() => setData({ mode: "home", countries: [] }));
  }, []);

  const countries = data?.mode === "home" ? data.countries || [] : [];
  if (!countries.length) return null;

  const hotelsCount = countries.reduce((sum, c) => sum + (c.hotelsCount || 0), 0);
  const citiesCount = countries.reduce((sum, c) => sum + (c.cities || []).length, 0);

  return (
    <section className="relative border-b border-slate-200 bg-[#F8F9FA] py-20 sm:py-24" data-testid="hotels-teaser">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-center justify-between gap-8 rounded-3xl border border-slate-200 bg-white p-8 sm:p-10 shadow-sm">
          <div className="flex items-start gap-5">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#C80000]/10 text-[#C80000]">
              <Building2 className="h-7 w-7" />
            </span>
            <div>
              <SectionHeading caption="مختارة وموثقة" title="فنادق مقترحة" />
              <p className="mt-3 max-w-xl text-sm sm:text-base text-slate-600 leading-relaxed">
                فنادق 4 و5 نجوم راجعناها لك في {countries.length} {countries.length === 1 ? "دولة" : "دول"} و{citiesCount} مدينة — {hotelsCount} فندقًا موثقًا. اطلب التسعير عبر واتساب ويؤكد المكتب السعر والتوفر.
              </p>
            </div>
          </div>
          <Link to="/hotels" data-testid="hotels-teaser-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#C80000] px-8 py-4 text-sm font-bold text-white transition-colors hover:bg-[#A60000] shadow-[0_16px_50px_-12px_rgba(200,0,0,0.5)]">
            تصفح الفنادق المقترحة
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
